/*
 * Created with vue 2
 * Author: Jay/jaytanweb@163.com
 * Date: 2018/4/24
 * Time: 13:58
 */
<template>
  <div id='loading' class="loading">
    <div class="load-box">
      <span class="count-down">{{ countDownNum }}%</span>
      <div class="bars bar-left"><span class="inside"></span></div>
      <div class="bars bar-right"><span class="inside"></span></div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'loading',
  data () {
    return {
      countDownNum: 1,
      barsInside: null,
      barWidth: null
    }
  },
  computed: {
    plusCountDown () {
      return this.countDownNum + 1
    },
    ...mapState([
      'ifShowLoad',
      'doFastEnd'
    ])
  },
  components: {},
  methods: {
    ...mapMutations([
      'setLoadVisible'
    ]),
    initCountModel () {
      this.barsInside = document.querySelectorAll('.inside')
      this.barWidth = document.querySelectorAll('.bars')[0].offsetWidth
    },
    counting () {
      // if (!this.ifShowLoad) {
      //   let load = document.getElementById('loading')
      //   load.classList.add('loading-none')
      //   return false
      // }
      if (this.doFastEnd) {
        // 在page2.vue完成图片接口数据获取后，会将'ifShowLoad'置为false，引发counting加速
        // console.log('doing fastEnd')
        this.countDownNum = this.plusCountDown
        if (this.countDownNum === 100) {
          // this.setLoadVisible(false)
          let load = document.getElementById('loading')
          load.classList.add('loading-close')
          setTimeout(() => load.classList.add('loading-none'), 100)
        } else {
          setTimeout(() => this.counting(), 20)
        }
      } else {
        this.countDownNum = this.plusCountDown
        if (this.countDownNum === 100) {
          let load = document.getElementById('loading')
          load.classList.add('loading-close')
          setTimeout(() => load.classList.add('loading-none'), 100)
        } else if (this.countDownNum > 90) {
          setTimeout(() => this.counting(), 250)
        } else {
          setTimeout(() => this.counting(), 50)
        }
      }
      this.barsInside.forEach(barInside => {
        barInside.style.width = `${(this.countDownNum / 100) * this.barWidth}px`
      })
    }
  },
  mounted () {
    // laoding mounted
    this.initCountModel()
    this.counting()
  }
}
</script>

<style type="text/scss" lang="scss" scoped>
.loading {
  //begin you code
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 1;
  transition: .5s;
  z-index: 8;
  .load-box {
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 50px;
    .bars {
      width: 40%;
      height: 2px;
      .inside {
        width: 100%;
        height: 100%;
        display: block;
        background: #fff;
      }
    }
    .bar-left {
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      .inside {
        float: right;
      }
    }
    .bar-right {
      position: absolute;
      top: 50%;
      right: 0;
      transform: translateY(-50%);
      .inside {
        float: left;
      }
    }
    .count-down {
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      display: inline-block;
      width: 20%;
      height: 100%;
      line-height: 50px;
      font-size: 32px;
      text-align: center;
      color: #fff;
    }
  }
}
.loading-close {
  opacity: 0;
}
.loading-none {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/loading.vue